import React from 'react';
import Img from 'gatsby-image';

const Image = ({aspectHeight, aspectWidth, sizes}) => {
    return (
        <div style={{width: '100%', position: 'relative', overflow: 'hidden'}}>
            <div style={{width: '100%', paddingTop: `calc((${aspectHeight}/${aspectWidth}) * 100%)`}}></div>
            <div style={{
                position: 'absolute',
                width: `100%`,
                top: 0,
                bottom: 0,
                left: '50%',
                transform: 'translate(-50%, 0)'
            }}>
                <Img
                sizes={sizes}
                style={{
                    position: "absolute",
                    left: 0,
                    top: 0,
                    width: "100%",
                    height: "100%"
                }}
                />
            </div>
        </div>
    )
}

export default Image;



// WEBPACK FOOTER //
// ./src/components/global/media/Image.js